import { loggerCan } from '@/data/utils/loggerUtil';
import { ContentType, HttpClient, RequestParams } from './http-client';
import { logger } from '@/logging/logger';
import { GeonodeGeonode, GetInventoryStoreBody, PhysicalStores } from './data-contracts';

export class GeonodeCustom<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	/**
	 * @tags transactions
	 * @name getPhysicalStores
	 * @summary Get clubdp cards
	 * @request GET:/store/{storeId}/location/GetPhysicalStores
	 * @secure
	 * @description Get physicalStores by uniqueID state
	 * @param {string} storeId - Store id
	 * @param {string} responseFormat - Response format
	 * @param {string} state - unidqueID state
	 * @param {RequestParams} params - request parameters
	 * @return {PhysicalStores} Clubdp cards
	 * @return {void} Clubdp cards
	 * @return {any} Clubdp cards
	 */
	getPhysicalStores = (
		storeId: string,
		query?: {
			responseFormat?: 'xml' | 'json';
			state?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('getPhysicalStores'))
		) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: null ?? {},
				methodName: 'getPhysicalStores',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<PhysicalStores, void>({
			path: `/store/${storeId}/location/GetPhysicalStores`,
			method: 'GET',
			query: query,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};

	/**
	 * @tags transactions
	 * @name getInventoryStore
	 * @summary post inventory store
	 * @request POST:/store/{storeId}/inventory/GetInventoryStore
	 * @secure
	 * @description Get physicalStores by uniqueID state
	 */
	getInventoryStore = (
		storeId: string,
		query?: {
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
		},
		data?: GetInventoryStoreBody,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('getInventoryStore'))
		) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: data ?? {},
				methodName: 'getInventoryStore',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<any, void>({
			path: `/store/${storeId}/inventory/GetInventoryStore`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};

	getCities = (
		storeId: string,
		state: string,
		query?: {
			responseFormat?: 'xml' | 'json';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('getPhysicalStores'))
		) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: null ?? {},
				methodName: 'getPhysicalStores',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<GeonodeGeonode, void>({
			path: `/store/${storeId}/geonode/byParentGeoNode/${state}`,
			method: 'GET',
			query: query,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
